import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Star, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const SpotlightAdminCard = () => {
  const [items, setItems] = useState([]);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/spotlight/all").then(({ data }) => setItems(data.spotlights || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!email.includes("@")) return toast.error("Enter the seller's email");
    setBusy(true);
    try {
      await api.post("/spotlight", { seller_email: email });
      toast.success("Spotlight created — AI wrote the story ✨");
      setEmail("");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="spotlight-admin-card">
      <div className="flex items-center gap-2">
        <Star className="h-4 w-4 text-amber-400" />
        <h2 className="font-bold text-lg">Seller spotlights</h2>
        <span className="text-[10px] uppercase tracking-wider text-neutral-500 border border-[#27272A] rounded-full px-2 py-0.5">
          rotates weekly on the landing page
        </span>
      </div>
      <div className="mt-4 flex gap-2">
        <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="spotlight-email-input"
          placeholder="Founding seller's email — AI drafts their story from their shop"
          className="flex-1 bg-black/40 border border-[#27272A] rounded-md text-xs px-3 py-2" />
        <button onClick={add} disabled={busy} data-testid="spotlight-add-btn"
          className="text-xs font-bold px-4 py-2 rounded-full bg-amber-400 text-black hover:bg-amber-300 disabled:opacity-50">
          {busy ? "Writing…" : "+ Spotlight"}
        </button>
      </div>
      {items.length > 0 && (
        <ul className="mt-4 space-y-2">
          {items.map((s, i) => (
            <li key={s.id} className="rounded-lg border border-[#27272A] bg-black/30 p-3 text-xs" data-testid={`spotlight-item-${s.id}`}>
              <div className="flex items-center gap-2">
                <span className="font-bold text-white">{s.seller_name}</span>
                {s.shop && <span className="text-neutral-500">· {s.shop}</span>}
                <span className="text-[9px] text-neutral-600 font-mono">week slot {i + 1}</span>
                <button onClick={async () => { await api.delete(`/spotlight/${s.id}`).catch(() => {}); load(); }}
                  className="ml-auto text-neutral-600 hover:text-[#FF3B30]" data-testid={`spotlight-del-${s.id}`}>
                  <Trash2 className="h-3.5 w-3.5" />
                </button>
              </div>
              <p className="mt-1.5 text-neutral-400 leading-relaxed">{s.story}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
